(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.directive('extraDaysHolidaysTable', ['DateService', ExtraDaysHolidaysTableDirectiveFn]);

    /* week scheme table directive */
    function ExtraDaysHolidaysTableDirectiveFn(DateService) {
        var directive = {
            restrict: 'E',
            link: link,
            replace: true,
            templateUrl: '/app/settings/agendasettings/modules/extradaysholidays/templates/extradaysholidays-table.template.html',
            controller: 'ExtraDayHolidayTableController',
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                days: '='
            }
        };
        return directive;

        function link(scope, element) {
            scope.fromDate = DateService.data.date;
        }
    }

})();